export default __webpack_public_path__ + "static/media/remix-studio-section-bg.0abeaf18.png";